import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
export class CompetitionResource extends BaseResource {
    pk() {
        return this.id.toString();
    }
}
CompetitionResource.urlRoot = apiResourceUrl("competitions");
export class CompetitionResultResource extends BaseResource {
    pk() {
        return `${this.competitionId}/results/${this.position}`;
    }
}
CompetitionResultResource.urlRoot = apiResourceUrl("competitions/{competitionId}/results");
//# sourceMappingURL=CompetitionResource.js.map